module.exports = __webpack_public_path__ + "static/goaisatsu@2x-993cde462d7181da133d3199c001d914.png";